export default {
  SETTING_UPDATED: 'Paramètre mis à jour',
  PASSWORD_UPDATED: `Mot de passe mis à jour`,
  USERNAME_UPDATED: `Nom d'utilisateur mis à jour`,
  PRONOUNS_UPDATED: `Pronoms mis à jour`,
  ATTRIBUTES_UPDATED: `Attributs mis à jour`,
  PIN_UPDATED: `NIP mis à jour`,
  ATTRIBUTE: {
    CREATED: `Attribut créé`,
    UPDATED: `Attribut modifié`
  },
  BREAK: {
    CREATED: `Pause créée`,
    UPDATED: `Pause modifiée`
  },
  BREAK_RULE: {
    CREATED: `Règle de pause créée`,
    UPDATED: `Règle de pause modifiée`
  },
  DEPARTMENT: {
    CREATED: `Département créé`,
    UPDATED: `Département modifié`
  },
  HIRING_DATA: {
    CREATED: `Donnée d'embauche créée`,
    UPDATED: `Donnée d'embauche modifiée`
  },
  WAGE_PREMIUM: {
    CREATED: `Code de prime créé`,
    UPDATED: `Code de prime modifié`
  },
  PERMISSION: {
    CREATED: `Permission créée`,
    UPDATED: `Permission modifiée`
  },
  POSITION: {
    CREATED: `Position créée`,
    UPDATED: `Position modifiée`
  },
  PUNCH_CARD: {
    CREATED: `Carte de temps créée`,
    UPDATED: `Carte de temps modifiée`
  },
  REQUEST_OPTION: {
    CREATED: `Raison / type de requête créée`,
    UPDATED: `Raison / type de requête modifiée`
  },
  SCHEDULE_TEMPLATE: {
    CREATED: `Modèle d'horaire créé`,
    UPDATED: `Modèle d'horaire modifié`
  },
  SCHEDULE_TYPE: {
    CREATED: `Type d'horaire créé`,
    UPDATED: `Type d'horaire modifié`
  },
  TAG: {
    CREATED: `Étiquette créée`,
    UPDATED: `Étiquette modifiée`
  },
  TEAM: {
    CREATED: `Équipe créée`,
    UPDATED: `Équipe modifiée`
  },
  ATTENDANCE: {
    CREATED: `Requête d'absence créée`,
    UPDATED: `Requête d'absence modifiée`
  },
  AVAILABILITY: {
    CREATED: `Disponibilité créée`,
    UPDATED: `Disponibilité modifiée`
  },
  TIME_OFF: {
    CREATED: `Congé créé`,
    UPDATED: `Congé modifié`
  },
  BULLETIN: {
    CREATED: `Annonce créée`,
    UPDATED: `Annonce modifiée`
  },
  NOTIFICATION_TEMPLATE: {
    CREATED: `Modèle de notification créé`,
    UPDATED: `Modèle de notification modifié`
  },
  PROJECT: {
    CREATED: `Projet créé`,
    UPDATED: `Projet modifié`
  },
  PUNCH_RULE: {
    CREATED: `Règle de carte de temps créée`,
    UPDATED: `Règle de carte de temps modifiée`
  },
  USER: {
    CREATED: `Utilisateur créé`,
    UPDATED: `Utilisateur modifié`
  },
  USER_TEMPLATE: {
    CREATED: `Modèle d'utilisateur créé`,
    UPDATED: `Modèle d'utilisateur modifié`
  },
  HOLIDAY: {
    CREATED: `Jour férié créé`,
    UPDATED: `Jour férié modifié`,
    DELETED: `Jour férié supprimé`
  },
  AVAILABILITY_IMPORT: {
    CREATED: `Disponibilités importées avec succès`
  },
  SCHEDULE_IMPORT: {
    CREATED: `Quarts de travail importés avec succès`
  },
  SCHEDULETEMPLATE_IMPORT: {
    CREATED: `Modèle d'horaire importé avec succès`
  },
  PUNCH_IMPORT: {
    CREATED: `Cartes de temps importées avec succès`
  },
  TIMEOFF_IMPORT: {
    CREATED: `Congés importés avec succès`
  },
  REPORT_INTERCOM: `Cliquez ici pour rapporter l'erreur`,
  JOB_RUN: {
    UPDATED: `Tâche exécutée avec succès`
  },
  PROJECTS_IMPORT: {
    CREATED: `Projets importés avec succès`
  },
  ALL_SHIFTS_FILLED: `Tous les quarts ont étés comblés`,
  SHIFTS_FILLED: `Un ou plusieurs quarts ont étés comblés`,
  NO_SHIFTS_FILLED: `Aucun quart de travail n'a pu être comblé`
}
